import React from "react"

export const SourcesInsulin = () => {

return(
<div>
https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8192250/<br />
https://www.nature.com/articles/s41586-023-06466-x.<br />
</div>
)
}